import axios from "#/net/axios";
import { Toast } from 'vant-ui'

import { getShopStaticResouceUrl, } from "#/utils/common.js"
import description from "./description.json"

/**
 * vuex
 */
const state = {
    description: description,
}

const getters = {

}

const mutations = {
    setDescription(state, data) {
        //
        state.description = data;
    },
}

const actions = {
    fetchDescription({ commit }) {
        axios.static_resource
                .get('data/description.json', null, {
                'Cache-Control': 'no-cache'
            })
            .then(data => {
                // handle success
                commit('setDescription', data)
            }).catch((error) => {
                // handle error
                Toast(`获取描述文件出错, ${error.toString()}`)
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
